import { RouterProvider } from 'react-router-dom';
import { Providers } from './providers';
import { router } from './router';
import { BiometricGate } from './BiometricGate';

/**
 * Root component. Mounts <Providers>, then <RouterProvider>. Non-React
 * navigation (axios interceptor logout, deep-link handler) goes through
 * the singleton in `shared/lib/navigation.ts`, which currently falls back
 * to `window.location.replace` — Phase B can rewire to `useNavigate` via
 * a route-element binding for smoother UX.
 */
export function App(): JSX.Element {
  return (
    <Providers>
      <BiometricGate>
        <RouterProvider router={router} />
      </BiometricGate>
    </Providers>
  );
}
